var Marionette = require('backbone.marionette');

var Constants = require('../../utils/constants');
var CommonUtils = require('../../utils/common-utils.js');

var DocumentsStatisticsView = Marionette.View.extend({
    template: require('../../templates/statistics/documents-statistics-view.html'),

    modelEvents: {
        change: 'render'
    },

    ui: {
        header: '.sort-header',
        sendingMethod: '#sending-method',
        mdNameFrom: '#md-name-from',
        mdNameTo: '#md-name-to',
        orgNameFrom: '#org-name-from',
        orgNameTo: '#org-name-to',
        filterField: '.filter-field',

        contactPopover: '.contact-popover',

        contactValueInput: '.contact-value-input',

        signedMdTotal: '#signed-md-total',
        pendingMdTotal: '#pending-md-total'
    },

    events: {
        'click @ui.header': 'headerSorting',
        'change @ui.filterField': 'onFilterFieldChanged',
        'click #sending-method a': 'onSelectSendingMethod',
        'keyup @ui.contactValueInput': 'onContactValueInputKeyUp'
    },

    initialize: function (options) {
        //_.bindAll(this, 'onRender', 'getSortedOrgPersons', 'headerSorting', 'onFilterFieldChanged', 'onSelectSendingMethod', 'filter');
        this.utils = new CommonUtils();

        this.selectedSendingMethods = [];
        this.sendingMethods = this.utils.getContactTypes();
        this.sendingMethodsState = _.keys(this.sendingMethods).map(function (method) {
            return {
                method: 'notActive'
            }
        });

        this.data = options.data;
        this.extraParamsAsString = options.extraParamsAsString;
        var initSortField = 'pending';
        var initSortDirection = 'desc';
        this.model = new Backbone.Model({
            orgperson: this.getSortedOrgPersons(initSortField, initSortDirection == 'desc' ? true : false, true),
            activeSort: initSortField,
            sortDirection: initSortDirection,
            mdNameFrom: "A",
            mdNameTo: "Z",
            orgNameFrom: "A",
            orgNameTo: "Z",
            contactValue: ''
        });
    },

    templateContext: function () {
        var that = this;
        return {
            orgSignedDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + id + '&object_status=SIGNED&object_status=VIEWED' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
            },
            orgPendingDocumentsLink: function (id) {
                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&ORGANIZATION_REVIEW_REQUEST=' + id + '&object_status=IN_REVIEW' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
            },
            personSignedDocumentsLink: function (orgId, id) {
                var result = '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&PERSON_REVIEW_FINISHED_REQUEST=' + id + '&object_status=SIGNED&object_status=VIEWED' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
                if (orgId != 'null') {
                    result += '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + orgId;
                }
                return result;
            },
            personPendingDocumentsLink: function (orgId, id) {
                var result = '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
                    + '&PERSON_REVIEW_REQUEST=' + id + '&object_status=IN_REVIEW' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
                if (orgId != 'null') {
                    result += '&ORGANIZATION_REVIEW_REQUEST=' + orgId;
                }
                return result;
            },
            transformSendingMethods: function (sendingMethods) {
                var groupedBySendingMethods = _.groupBy(sendingMethods, function (method) {
                    return method;
                });
                return _.keys(groupedBySendingMethods).map(function (method) {
                    return {
                        methodName: method,
                        count: (groupedBySendingMethods[method] || []).length > 1 ? groupedBySendingMethods[method].length : ''
                    }
                });
            },
            sendingMethods: that.sendingMethods,
            sendingMethodsState: that.sendingMethodsState,
            upperCaseChars: that.utils.getUpperCaseCharsList(),
            getContacts: function (contacts, type) {
                return (contacts || []).filter(function (contact) {
                    return contact.type == type;
                }).map(function (contact) {
                    return contact.data;
                })
            }
        }
    },

    onRender: function () {
        this.ui.contactPopover.popover();
        this.ui.contactPopover.on('shown.bs.popover', function () {
            var thisPopover = $(this);
            $('.popover-content').css({color: '#000', 'font-size': '12px;'});

            setTimeout(function () {
                thisPopover.popover('hide');
            }, 4000);
        });

        this.renderTotals();
    },

    getSortedOrgPersons: function (sortBy, reverseSort, beforeRender) {
        var that = this;

        var orgs = (that.data.orgperson || []).filter(function (orgStat) {
            return orgStat.pending + orgStat.signed > 0;
        });

        (orgs || []).forEach(function (orgStat) {
            if (orgStat.title)
                orgStat.title = orgStat.title.toUpperCase();
            else
                orgStat.title = "";
        });

        var orgNameFrom = beforeRender ? "A" : (that.model.get('orgNameFrom') || "A");
        var orgNameTo = beforeRender ? "Z" : (that.model.get('orgNameTo') || "Z");
        var orgContactValue = beforeRender ? "" : that.utils.normalizeContact((that.model.get('contactValue') || ""));

        orgs = orgs.filter(function (org) {
            return (that.selectedSendingMethods.length == 0
                || _.chain(that.selectedSendingMethods)
                    .map(function (method) {
                        return _.contains(org.sendingMethods, method);
                    })
                    .reduce(function (acc, value) {
                        return acc || value;
                    }, false)
                    .value())
                && (typeof org.title === "undefined" || org.title == null || org.title[0] >= orgNameFrom && org.title[0] <= orgNameTo)
                && (orgContactValue === "" || that.isHasContact(org.contacts || [], orgContactValue))
                || !org.title;
        });

        var sortedOrgs = _.sortBy(orgs || [], function (item) {
            return item[sortBy];
        });

        if (reverseSort)
            sortedOrgs = sortedOrgs.reverse();

        /*var nullOrgs = sortedOrgs.filter(function (org) {
         return org.id === 'null';
         });
         sortedOrgs = sortedOrgs.filter(function (org) {
         return org.id !== 'null';
         });
         if (nullOrgs.length > 0) {
         sortedOrgs.unshift(nullOrgs[0]);
         }*/

        sortedOrgs.forEach(function (orgStat) {
            orgStat.personsList = [];
            for (personId in orgStat.itemsMap) {
                if (orgStat.itemsMap[personId].pending + orgStat.itemsMap[personId].signed > 0
                    && orgStat.itemsMap[personId].id != null && orgStat.itemsMap[personId].id != 'null') {
                    orgStat.personsList.push(orgStat.itemsMap[personId]);
                }
            }

            orgStat.personsList.forEach(function (personStat) {
                if (personStat.title)
                    personStat.title = personStat.title.toUpperCase();
            });

            var mdNameFrom = beforeRender ? "A" : (that.model.get('mdNameFrom') || "A");
            var mdNameTo = beforeRender ? "Z" : (that.model.get('mdNameTo') || "Z");
            var mdContactValue = beforeRender ? "" : that.utils.normalizeContact((that.model.get('contactValue') || ""));

            orgStat.personsList = orgStat.personsList.filter(function (person) {
                return (that.selectedSendingMethods.length == 0
                    || _.chain(that.selectedSendingMethods)
                        .map(function (method) {
                            return _.contains(person.sendingMethods, method);
                        })
                        .reduce(function (acc, value) {
                            return acc || value;
                        }, false)
                        .value())
                    && (person.title || "")[0] >= mdNameFrom && (person.title || "")[0] <= mdNameTo
                    && (mdContactValue === "" || that.isHasContact(person.contacts || [], mdContactValue));
            });

            orgStat.personsList = _.sortBy(orgStat.personsList, function (item) {
                return item[sortBy];
            });

            if (reverseSort)
                orgStat.personsList = orgStat.personsList.reverse();

        });

        sortedOrgs = sortedOrgs.filter(function (orgStat) {
            var contactValue = beforeRender ? "" : that.utils.normalizeContact((that.model.get('contactValue') || ""));
            var orgIsNotEmpty = orgStat.personsList.length > 0;
            var orgIsInDeliveryMethodFilter =
                that.selectedSendingMethods.length == 0 ||
                _.chain(that.selectedSendingMethods)
                    .map(function (method) {
                        return _.contains(orgStat.sendingMethods, method);
                    })
                    .reduce(function (acc, value) {
                        return acc || value;
                    }, false)
                    .value();
            var orgIsInFaxFilter = contactValue === "" ||
                (orgStat.personsList.length == 0 && that.isHasContact(orgStat.contacts || [], contactValue));

            return orgIsNotEmpty || (orgIsInDeliveryMethodFilter && orgIsInFaxFilter);
        });

        return sortedOrgs;
    },

    headerSorting: function (event) {
        var sortField = event.target.id;
        if (this.model.get('activeSort') != sortField) {
            this.model.set('sortDirection', 'asc');
            this.model.set('activeSort', sortField);
        }
        else if (this.model.get('activeSort') == sortField) {
            if (this.model.get('sortDirection') == 'desc')
                this.model.set('sortDirection', 'asc');
            else
                this.model.set('sortDirection', 'desc');
        }

        this.model.set('orgperson', this.getSortedOrgPersons(sortField, this.model.get('sortDirection') == 'desc' ? true : false));
    },

    onFilterFieldChanged: function (event) {
        var jqElement = $(event.target);
        this.model.set(jqElement.attr("name"), jqElement.val());
        this.filter();
    },

    onSelectSendingMethod: function (event) {
        var target = $(event.target);
        var value = target.data('title');
        var isActive = target.hasClass('active');

        if (!isActive) {
            target.removeClass('notActive').addClass('active');
            this.sendingMethodsState[value] = 'active';
            this.selectedSendingMethods.push(value);
        } else {
            target.removeClass('active').addClass('notActive');
            this.sendingMethodsState[value] = 'notActive';
            this.selectedSendingMethods = _.reject(this.selectedSendingMethods, function (method) {
                return method == value;
            });
        }

        this.filter();
    },

    onContactValueInputKeyUp: function (event) {
        if (event.keyCode == 13 && event.target.value.length > 2 || _.isEmpty(event.target.value)) {
            var jqEl = $(event.target);
            this.model.set(jqEl.attr('name'), event.target.value);
            this.filter();
        }
    },

    filter: function () {
        this.model.set('orgperson',
            this.getSortedOrgPersons(this.model.get('activeSort'),
                this.model.get('sortDirection') == 'desc' ? true : false));
        this.model.set('stateUuid', this.utils.generatedUUID());
    },

    isHasContact: function (contacts, searched) {
        var that = this;
        if (_.isEmpty(contacts))
            return false;
        return _.chain(contacts)
            .map(function (contact) {
                return that.utils.normalizeContact(contact.data || "").indexOf(that.utils.normalizeContact(searched)) > -1;
            })
            .reduce(function (acc, value) {
                return acc || value;
            }, false)
            .value();
    },

    renderTotals: function () {
        var orgPersons = this.model.get('orgperson');
        var signedCount = 0;
        var pendingCount = 0;
        /*_.chain(orgPersons).map(function (orgPerson) {
            return orgPerson.personsList;
        }).flatten().each(function (person) {
            signedCount = signedCount + person.signed;
            pendingCount = pendingCount + person.pending;
        });*/
        _.chain(orgPersons).each(function (org) {
            signedCount = signedCount + org.signed;
            pendingCount = pendingCount + org.pending;
        });
        this.ui.signedMdTotal.text(signedCount);
        this.ui.pendingMdTotal.text(pendingCount);
    }
});


module.exports = DocumentsStatisticsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/statistics/documents-statistics-view.js
// module id = 303
// module chunks = 0